import React, { FunctionComponent } from 'react';
import styles from './schema-block.module.scss';
import arrowBottom from '../../assets/images/arrow-bottom.svg';
import arrowTop from '../../assets/images/arrow-top.svg';

export interface ISchemaBlockProps {
  text: string;
  hasCircleIcon: boolean;
  arrowSeparatorAfterBlock: boolean;
}

export const SchemaBlock: FunctionComponent<ISchemaBlockProps> = ({
  text,
  arrowSeparatorAfterBlock,
  hasCircleIcon
}) => {
  return (
    <div
      className={`
        ${styles.wrapper} 
        ${arrowSeparatorAfterBlock && styles.wrapperWithSeparator}`}
    >
      <div className={styles.schemaBlock}>
        {hasCircleIcon && (
          <div className={styles.arrowsSmall}>
            <img src={arrowTop} alt="arrow top" />
            <img src={arrowBottom} alt="arrow bottom" />
          </div>
        )}
        {text}
      </div>
      {arrowSeparatorAfterBlock && (
        <div className={styles.arrowsLarge}>
          <img src={arrowTop} alt="arrow top" />
          <img src={arrowBottom} alt="arrow bottom" />
        </div>
      )}
    </div>
  );
};
